module.exports = __webpack_public_path__ + "static/media/p9.203b2aad.png";